import React, { Fragment } from 'react';
import { CardBody, Col } from 'reactstrap';
import { H6 } from '../../../AbstractElements';
import SmallSales1 from './SmallSales1';
import SmallSales2 from './SmallSales2';

const SmallSales = () => {
  return (
    <Fragment>
      <Col xs='4' className="p-0">
        <div className="sales-small-chart">
          <CardBody className="p-0 m-auto">
            <H6>300</H6><span>Watch Sale</span>
          </CardBody>
        </div>
      </Col>
      <SmallSales1 />
      <SmallSales2 />
    </Fragment>
  );
};
export default SmallSales;